<template>
  <div class="mail-list coming-soon">
    <page-header title="通讯录" />

    <div class="options">
      <el-button type="primary">导出</el-button>
    </div>
    <ming-table :fields="column" :data="data" />
  </div>
</template>

<script setup>
import { ApplyStudentStatusColumn } from '../MyCourse/tableColumn'
import PageHeader from '@/components/PageHeader'

import { ref } from 'vue'

const column = ref(ApplyStudentStatusColumn)
const data = ref([])
</script>

<style lang="scss" scoped>
  .options {
    padding: 20px 0;
  }
</style>
